import React from "react";

import { TableCell, TableRow } from "@mui/material";
import clsx from "clsx";

import mainStyles from "../../../styles";

export const UserFieldsTableHeader = () => {
  const classes = mainStyles();
  return (
    <TableRow data-testid="user-field-table-header">
      <TableCell
        className={clsx(classes.tableCell)}
        align="center"
        sx={{ fontWeight: "bold" }}
      >
        Name
      </TableCell>
      <TableCell
        className={clsx(classes.tableCell)}
        align="center"
        sx={{ fontWeight: "bold", width: "20%" }}
      >
        Description
      </TableCell>
      <TableCell
        className={clsx(classes.tableCell)}
        align="center"
        sx={{ fontWeight: "bold" }}
      >
        Data Type
      </TableCell>
      <TableCell
        className={clsx(classes.tableCell)}
        align="center"
        sx={{ fontWeight: "bold", width: "32%" }}
      >
        Options
      </TableCell>
      <TableCell
        className={clsx(classes.tableCell)}
        align="center"
        sx={{ fontWeight: "bold" }}
      >
        In Use
      </TableCell>
    </TableRow>
  );
};
